import { inject, Injectable, InjectionToken } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type TDialogLikeRef<T> = Pick<MatDialogRef<T>, 'close'> & { name?: string };

export const ALT_MAT_DIALOG_REF = new InjectionToken<TDialogLikeRef<any>>('ALT_MAT_DIALOG_REF');

@Injectable()
export class AdaptiveMatDialogRef<ClosePayload, Component> {
  public readonly ref: TDialogLikeRef<ClosePayload> =
    inject(ALT_MAT_DIALOG_REF, { optional: true }) ?? inject(MatDialogRef<Component, ClosePayload>);

  public close(result?: ClosePayload): void {
    this.ref.close(result);
  }
}

export class IframeDialogRef<T> implements TDialogLikeRef<T> {
  public readonly name = 'iframe' as const;

  public close(result?: T): void {
    window.parent.postMessage(
      {
        payload: result,
        type: 'DIALOG_CLOSED',
      },
      '*',
    );
  }
}
